import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
  aside?: ReactNode;
}

export default function PageHeader({ title, subtitle, crumbs, aside }: PageHeaderProps) {
  return (
    <section className="w-full bg-primary-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-8 md:py-12">
        {crumbs && (
          <div className="mb-5 [&_a]:text-white/60 [&_a:hover]:text-white [&_span]:text-white/90 [&_i]:text-white/30">
            <Breadcrumb items={crumbs} />
          </div>
        )}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-4xl font-semibold text-white tracking-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-3 text-sm md:text-base text-white/65 max-w-2xl leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
          {aside && <div className="shrink-0">{aside}</div>}
        </div>
      </div>
    </section>
  );
}